export default __webpack_public_path__ + "static/sopharma-ee20b53a65e5287b83f178de3a625497.svg";